import { Guid } from "../../types/guid.type";
import { EntityBase, IEntityBaseInfo } from "../entity/entitybase";

export interface ITaskCategoryInfo extends IEntityBaseInfo {
  Label?: string;
  Description?: string;
  ColorHexa?: string;
  AuthorUid?: Guid;
  AuthorName?: string;
  TenantAppUids?: Guid[];
}

export class TaskCategory extends EntityBase {
  Label?: string;
  Description?: string;
  ColorHexa?: string;
  AuthorUid?: Guid;
  AuthorName?: string;
  TenantAppUids?: Guid[];

  // Client side properties for task summary
  TotalDays?: number;
  RecurringTasks?: number;
  OverdueTasks?: number;
  UrgentTasks?: number;
  ValidationTasks?: number;

  constructor(info: ITaskCategoryInfo) {
    super(info);

    this.Label = info.Label;
    this.Description = info.Description;
    this.ColorHexa = info.ColorHexa;
    this.AuthorUid = info.AuthorUid;
    this.AuthorName = info.AuthorName;
    this.TenantAppUids = info.TenantAppUids ?? [];

    // Initialize summary properties
    this.TotalDays = 0;
    this.RecurringTasks = 0;
    this.OverdueTasks = 0;
    this.UrgentTasks = 0;
    this.ValidationTasks = 0;
  }

  override title(): string {
    return `Tâche : ${this.Label}`;
  }

  override description(): string {
    return `Description : ${this.Description}`;
  }
}
